import styled from 'styled-components'

const ModalFooter = styled.div``

export default ModalFooter